import gql from 'graphql-tag';

export class FormInput {
  id?: number;
  name: string;
  isActive?: boolean;

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.isActive = undefined;
  }
}

export const gqlGetQuery = gql`
  query getProfessions($limit: Int, $offset: Int, $order: String, $where: String) {
    getProfessions(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        isActive
        firstDate
        firstUser
        lastDate
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getProfessionById($id: Int) {
    getProfessionById(id: $id) {
      id
      name
      isActive
      firstDate
      firstUser
      lastDate
      lastUser
    }
  }
`;

export const gqlAdd = gql`
  mutation addProfession($data: ProfessionInput) {
    addProfession(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateProfession($data: ProfessionInput) {
    updateProfession(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteProfession($id: Int) {
    deleteProfession(id: $id)
  }
`;
